import React from 'react';

import { useNavigate } from 'react-router-dom';
import { FormikValues } from 'formik';

import {
  BroadcastNotificationType,
  deleteBroadcastNotification,
} from '@pharmaplan/common';

import DeactivateDialog from '../../../components/Admin/PharmacistList/DeactivateDialog';
import { Constants, DeactivateModalIcon } from '../../../helpers/Constants';
import { setDialog } from '../../../reducers/dialogReducer';
import { useAppDispatch } from '../../useAppDispatch';
import strings from '../../../localization';

const { editNotification } = Constants.paths.admin;
const idsKey = 'broadcastNotificationIds';

const useBroadcastNotificationActions = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleEdit = (notificationId: string, notificationType: BroadcastNotificationType) =>
    () => {
      navigate(editNotification, {
        state: { id: notificationId, notificationType },
      });
    };

  const confirmAction = (values: FormikValues) => {
    const { reason } = values ?? {};
    dispatch(
      deleteBroadcastNotification({
        broadcastNotificationIds: values?.[idsKey] ?? [],
        reason,
      }),
    );
  };

  const showDeleteDialog = (ids: Array<string>, confirmationMessage: string) => {
    dispatch(
      setDialog({
        Component: (
          <DeactivateDialog
            onSubmit={confirmAction}
            confirmationMessage={confirmationMessage}
            id=""
            initialValues={{
              [idsKey]: ids,
              reason: '',
            }}
            heading={strings.delete}
            iconType={DeactivateModalIcon.warning}
            validator={null}
          />
        ),
        showCloseButton: true,
        heading: {
          title: '',
        },
      }),
    );
  };

  const handleDelete = (id: string) =>
    () => {
      showDeleteDialog([id], strings.areYouSureDeleteEntry);
    };

  const handleMultipleDelete = (ids: Array<string>) =>
    () => {
      if (!ids.length) {
        return;
      }

      showDeleteDialog(
        ids,
        strings.formatString(
          strings.areYouSureDeleteSelectedEntries,
          ids.length,
        ) as string,
      );
    };

  return { handleEdit, handleDelete, handleMultipleDelete };
};

export default useBroadcastNotificationActions;
